exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-signup-order[data-v-f0f9b2da]{display:flex;flex-direction:column}\n", ""]);

